<template>
  <div class="contactus-4 pt-100 pb-150 petit">
    <!-- CGV
    <modal :show.sync="modals.modal1" modal-classes="modal-dialog-centered">
      <h5 slot="header" class="modal-title" id="modal-title-default">
        Conditions Générales de Vente
      </h5>

      <ul>
        <li>
          <b>Article 1 : Dispositions générales</b>
          Nos ventes sont soumises aux présentes conditions générales qui
          prévalent sur toutes conditions d'achat de l'ACHETEUR. En conséquence,
          toute passation de commande par un ACHETEUR emporte pleine et entière
          adhésion aux présentes conditions générales de vente. Sauf contrat
          spécifique entre HYPOTHECA et son ACHETEUR, toutes modifications ou
          réserves vis-à-vis de ces conditions même spécifiées par écrit par le
          client n'engagent nullement HYPOTHECA, à moins que les dites
          modifications aient été expressément acceptées et contresignées par
          HYPOTHECA.
        </li>
        <br />
        <li>
          <b>Article 2: Définition</b>
          Pour la bonne compréhension des présentes conditions générales de
          vente, il convient de donner aux termes suivants les définitions
          ci-après. HYPOTHECA : Ce terme désigne LE VENDEUR qui commercialise un
          service permettant d'obtenir des données publiques relatives à la
          publicité foncière, sur le territoire national. L'ACHETEUR : Ce terme
          désigne le consommateur qui achète à HYPOTHECA SAS des produits.
        </li>
        <br />
        <li>
          <b>Article 3 : Validation et acceptation de la commande</b>
          La commande est effective par la seule validation du panier
          électronique et le règlement par carte bancaire. Toute commande
          émanant du client ne sera considérée par HYPOTHECA comme définitive,
          et n'engage HYPOTHECA, que si elle est impérativement accompagnée du
          règlement correspondant. Si le client souhaite modifier sa commande
          (parcelle, section etc...) il ne peut le faire que dans les 12 heures
          qui suivent sa demande. Au-delà, la commande peut être déjà traitée et
          aucune modification ne sera possible.
        </li>
        <br />
        <li>
          <b>Article 4: Mode de règlement</b>
          <br />Tout produit est payable à la commande, au comptant, par chèque
          bancaire, par carte bancaire ou par espèce. Par chèque bancaire :
          directement à l'ordre et à l'adresse de : <br /><b
            >HYPOTHECA <br />CABINET ANHOD <br />52 RUE JULES CLARETIE
            <br />31400 TOULOUSE</b
          >
          <br />Accompagné du bon de commande. HYPOTHECA se réserve le droit de
          ne traiter la commande qu'après avoir vérifié la régularité du
          paiement.
        </li>
        <br />
        <li>
          <b>Article 5: Livraison et Délais</b>
          HYPOTHECA ne peut pas s'engager sur des délais contractuels,
          l'obtention des informations commandées par l'ACHETEUR étant
          subordonnée aux délais des différents SERVICE DE PUBLICITE FONCIERE.
          La commande, une fois le panier validé et le règlement effectué, est
          prise en charge dans les 24 heures. Un mail confirmant à l'ACHETEUR
          que la commande est complète et valide sera envoyé à ce dernier.
          <br />
          Sauf sur demande expresse du client et facturé en supplément, la
          livraison des informations commandées par l'ACHETEUR sera effectuée
          par mail, dès réception du retour du SPF.
        </li>
        <br />
        <li>
          <b>Article 6: Perte ou vol</b>
          HYPOTHECA ne saurait être responsable de quelque manière que ce soit
          d'une perte ou d'un vol des produits survenant après livraison
          effectuée à l'ACHETEUR.
        </li>
        <br />
        <li>
          <b>Article 7: Responsabilités</b>
          A l'exclusion des cas visés à l'article qui précède, la responsabilité
          de HYPOTHECA ne saurait être recherchée ou actionnée par l'ACHETEUR.
          HYPOTHECA ne pourra être tenu pour responsable de l'inexécution du
          contrat en cas d'informations incomplètes fournies par l'ACHETEUR lors
          du passage de la commande, en cas de force majeure, de perturbation ou
          de grève totale ou partielle, notamment des services postaux, des
          services de la publicité foncière, et moyens de transports et/ou de
          communications.
        </li>
        <br />
        <li>
          <b
            >Article 8: Politique de confidentialité et traitement des
            données</b
          >
          <ul>
            <br />
            <li>
              <b>Collecte de l'information :</b> Nous recueillons des
              informations lorsque vous vous inscrivez sur notre site, lorsque
              vous vous connectez à votre compte, faites un achat. Les
              informations recueillies incluent votre nom, votre adresse e-mail,
              numéro de téléphone, adresse. Le numéro de carte bleue inscrit
              lors du paiement n'est pas enregistré sur nos serveurs. Le
              règlement par carte bleue est effectué par l'intermédiaire du
              Crédit Agricole qui est seul habilité à effectuer le règlement.
            </li>
            <br />
            <li>
              <b>Utilisation des informations :</b>Toute les informations que
              nous recueillons auprès de vous peuvent être utilisées effectuer
              votre commande, améliorer le service client et vos besoins de
              prise en charge, vous contacter par e-mail. Aucun démarchage ne
              sera effectué avec les informations transmises.
            </li>
            <br />
            <li>
              <b>Confidentialité :</b>Nous sommes les seuls propriétaires des
              informations recueillies sur ce site. Vos informations
              personnelles ne seront pas vendues, échangées, transférées, ou
              données à une autre société pour n’importe quel raison, sans votre
              consentement, en dehors de ce qui est nécessaire pour répondre à
              une demande et / ou une transaction. Les commandes que vous
              effectuez sur notre site sont strictement confidentielles. Vos
              coordonnées ne seront pas communiqués au Service de la Publicité
              Foncière que ce soit pour la copie d'un acte ou la demande d'un
              état hypothécaire.
            </li>
            <br />
            <li>
              <b>Protection des informations :</b> Nous mettons en œuvre une
              variété de mesures de sécurité pour préserver la sécurité de vos
              informations personnelles. Nous utilisons un cryptage à la pointe
              de la technologie pour protéger les informations sensibles
              transmises en ligne. Nous protégeons également vos informations
              hors ligne. Seuls les employés qui ont besoin d’effectuer un
              travail spécifique (par exemple, la vérification des coordonnées
              cadastrales, la facturation ou le service à la clientèle) ont
              accès aux informations personnelles identifiables. Les ordinateurs
              et serveurs utilisés pour stocker des informations personnelles
              identifiables sont conservés dans un environnement sécurisé.
            </li>
            <br />
            <li>
              <b>Cookies :</b>A l’occasion de la consultation de notre site
              internet, nous pouvons être amenés, si vous l’acceptez, à déposer
              sur votre ordinateur, grâce à votre logiciel de navigation, des
              cookies. Les cookies nous permettent pendant leur durée de
              validité ou d’enregistrement, d’identifier votre ordinateur lors
              de vos prochaines visites. Principal cookie utilisé : Identifiant
              de cession
            </li>
            <br />
            <li>
              <b>Se désinscrire :</b>Nous utilisons l’adresse e-mail que vous
              fournissez pour vous envoyer des informations et mises à jour
              relatives à votre commande, des nouvelles de l’entreprise de façon
              occasionnelle. Si à n’importe quel moment vous souhaitez vous
              désinscrire et ne plus recevoir d’e-mails, des instructions de
              désabonnement détaillées sont incluses en bas de chaque e-mail.
            </li>
            <br />
            <li>
              <b
                >Les informations recueillies sur ce site sont nécessaires au
                traitement de votre demande. Elles pourront être communiquées
                aux personnes intervenant dans la souscription, la gestion et
                l’exécution du contrat. Vous disposez d’un droit d’accès, de
                rectification, de suppression et de portabilité pour toute
                information vous concernant auprès du Cabinet ANHOD- HYPOTHECA,
                52 rue Jules Clarétie – 31400 Toulouse; conformément aux
                dispositions du Règlement Général de Protection des Données
                (RGPD) en date du 27 avril 2016.</b
              >
            </li>
          </ul>
          <br />
        </li>

        <li>
          <b>Article 9 : Service clientèle et suivi de commande</b>
          Pour toute information ou question, le service clientèle de HYPOTHECA
          est à la disposition de l'ACHETEUR : Adresse : HYPOTHECA, CABINET
          ANHOD - 52 rue Jules Clarétie - 31400 Toulousev Téléphone :
          05.61.83.29.13 E-mail : contact@hypotheca.fr Toute réclamation, pour
          être suivie d'effet, devra être notifiée par courrier motivé, par
          lettre simple.
        </li>
        <br />
        <li>
          <b
            >Article 10 : Opposabilité des présentes conditions générales de
            ventes</b
          >
          Par la signature du bon de commande, le client reconnaît avoir pris
          connaissance des présentes conditions générales de ventes et les avoir
          acceptées.
        </li>
        <br />
        <li>
          <b
            >Article 11 : Loi applicable et clause attributive de juridiction</b
          >
          Les présentes conditions générales de vente sont régies par le droit
          français. A défaut de règlement amiable par les parties, tous
          différends qui pourraient survenir, relatifs à la conclusion,
          l'interprétation ou l'exécution des présentes, ses suites ou ses
          conséquences, seront réglés par le Tribunal de Commerce de Toulouse
          ou, à défaut, par le Tribunal compétent situé dans la Juridiction du
          défendeur à l'instance.
        </li>
        <br />
        <li>
          <b>EXTRAITS DU CODE DE LA CONSOMMATION</b>
          <ul>
            <br />
            <li>
              <b>Article L121-21 :</b> Est soumis aux dispositions de la
              présente section quiconque pratique ou fait pratiquer le
              démarchage, au domicile d'une personne physique, à sa résidence ou
              à son lieu de travail, même à sa demande, afin de lui proposer
              l'achat, la vente, la location, la location-vente ou la location
              avec option d'achat de biens ou la fourniture de services. Est
              également soumis aux dispositions de la présente section le
              démarchage dans les lieux non destinés à la commercialisation du
              bien ou du service proposé et notamment l'organisation par un
              commerçant ou à son profit de réunions ou d'excursions afin de
              réaliser les opérations définies à l'alinéa précédent.
            </li>
            <br />
            <li>
              <b>Article L121-23:</b> Les opérations visées à l'article L.
              121-21 doivent faire l'objet d'un contrat dont un exemplaire doit
              être remis au client au moment de la conclusion de ce contrat et
              comporter, à peine de nullité, les mentions suivantes : 1º Noms du
              fournisseur et du démarcheur ; 2º Adresse du fournisseur ; 3º
              Adresse du lieu de conclusion du contrat ; 4º Désignation précise
              de la nature et des caractéristiques des biens offerts ou des
              services proposés ; 5º Conditions d'exécution du contrat,
              notamment les modalités et le délai de livraison des biens, ou
              d'exécution de la prestation de services ; 6º Prix global à payer
              et modalités de paiement ; 7º Faculté de renonciation prévue à
              l'article L. 121-25, ainsi que les conditions d'exercice de cette
              faculté et, de façon apparente, le texte intégral des articles L.
              121-23, L. 121-24, L. 121-25 et L. 121-26.
            </li>
            <br />
            <li>
              <b>Article L121-24:</b> Le contrat visé à l'article L. 121-23 doit
              comprendre un formulaire détachable destiné à faciliter l'exercice
              de la faculté de renonciation dans les conditions prévues à
              l'article L. 121-25. Un décret en Conseil d'Etat précisera les
              mentions devant figurer sur ce formulaire. Ce contrat ne peut
              comporter aucune clause attributive de compétence. Tous les
              exemplaires du contrat doivent être signés et datés de la main
              même du client.
            </li>
            <br />
            <li>
              <b>Article L121-25:</b> Dans les sept jours, jours fériés compris,
              à compter de la commande ou de l'engagement d'achat, le client a
              la faculté d'y renoncer par lettre recommandée avec accusé de
              réception. Si ce délai expire normalement un samedi, un dimanche
              ou un jour férié ou chômé, il est prorogé jusqu'au premier jour
              ouvrable suivant. Toute clause du contrat par laquelle le client
              abandonne son droit de renoncer à sa commande ou à son engagement
              d'achat est nulle et non avenue. Le présent article ne s'applique
              pas aux contrats conclus dans les conditions prévues à l'article
              L. 121-27.
            </li>
            <br />
            <li>
              <b>Article L121-26:</b> (Loi nº 95-96 du 1 février 1995 art. 8
              Journal Officiel du 2 février 1995) Avant l'expiration du délai de
              réflexion prévu à l'article L. 121-25, nul ne peut exiger ou
              obtenir du client, directement ou indirectement, à quelque titre
              ni sous quelque forme que ce soit une contrepartie quelconque ni
              aucun engagement ni effectuer des prestations de services de
              quelque nature que ce soit. Toutefois, la souscription à domicile
              d'abonnement à une publication quotidienne et assimilée, au sens
              de l'article 39 bis du code général des impôts, n'est pas soumise
              aux dispositions de l'alinéa précédent dès lors que le
              consommateur dispose d'un droit de résiliation permanent, sans
              frais ni indemnité, assorti du remboursement, dans un délai de
              quinze jours, des sommes versées au prorata de la durée de
              l'abonnement restant à courir. En outre, les engagements ou ordres
              de paiement ne doivent pas être exécutés avant l'expiration du
              délai prévu à l'article L. 121-25 et doivent être retournés au
              consommateur dans les quinze jours qui suivent sa rétractation."
            </li>
            <br />
            <li>
              <b
                >Renoncement au délai de rétractation : Dans la mesure où la
                prestation de service est pleinement exécutée avant la fin du
                délai de rétractation et que l'exécution a commencé après accord
                préalable exprès du consommateur à renoncer à son droit de
                rétractation, le droit de rétractation ne peut pas être
                exercée.</b
              >
              <br /><br />
              <br />
            </li>
          </ul>
        </li>
      </ul>
    </modal> -->
    <modal :show.sync="modals.modal2" modal-classes="modal-xl">
      <h4 slot="header" class="modal-title" id="modal-title-default">
        Vous ne pouvez pas régler le solde aujourd'hui ?
      </h4>

      <div class="py-3 text-center">
        <h4 class="heading mt-4" style="color: #222222;">
          Rassurez-vous : vous avez différentes options
        </h4>
        <br /><br />
        <div class="row">
          <div class="col-md-4">
            <div class="row" style="color: #222222;">
              <div class="col-md-12 pb-4">Régler par <br />mensualités ?</div>
            </div>
            <div class="row pb-5">
              <div class="col-md-12">
                <!-- BTN Quand écheancier actif
                <base-button
                  block
                  type="anhod1"
                  @click="modals.modal2 = false"
                  v-scroll-to="'#echeancier'"
                  ><i class="ni ni-calendar-grid-58"></i>
                  Échéancier</base-button
                >
                -->
                <router-link to="/messages/3">
                  <base-button
                    block
                    type="anhod1"
                    @click="modals.modal2 = false"
                    ><i class="ni ni-calendar-grid-58"></i>
                    Échéancier</base-button
                  >
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row" style="color: #222222;">
              <div class="col-md-12 pb-4">
                Vous attendez des fonds<br />
                prochainement ?
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <router-link to="/messages/2">
                  <!-- Ajouter les parmètre pour définir le type de message -->
                  <base-button
                    block
                    type="anhod1"
                    @click="modals.modal2 = false"
                    ><i class="ni ni-time-alarm"></i> Délai</base-button
                  >
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row" style="color: #222222;">
              <div class="col-md-12 pb-4">Contacter un <br />conseiller ?</div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <router-link to="/messages/1">
                  <!-- Ajouter les parmètre pour définir le type de message -->
                  <base-button
                    block
                    type="anhod1"
                    @click="modals.modal2 = false"
                    ><i class="ni ni-email-83"></i> Contactez-nous</base-button
                  >
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod1"
          class="ml-auto"
          @click="modals.modal2 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <!-- ECHEANCIER
    <modal
      :show.sync="modals.modal3"
      gradient="anhod3"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h4
        slot="header"
        class="modal-title"
        id="modal-title-notification"
        style="color: #222222;"
      >
        Vous avez une demande spécifique concernant l'échéancier?
      </h4>

      <div class="py-3 text-center">
        <h4 class="heading mt-4" style="color: #222222;">
          Rassurez-vous : vous pouvez nous contacter de deux manière
        </h4>
        <br /><br />
        <div class="row">
          <div class="col-md-6">
            <div class="row" style="color: #222222;">
              <div class="col-md-12 pb-4">Par message ?</div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <router-link to="/messages/3">
                  <base-button
                    block
                    type="anhod1"
                    @click="modals.modal3 = false"
                    ><i class="ni ni-email-83"></i
                  ></base-button>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row" style="color: #222222;">
              <div class="col-md-12 pb-4">
                Par téléphone ?
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <router-link to="/contact">
                  <base-button
                    block
                    type="anhod1"
                    @click="modals.modal3 = false"
                    >Contactez nous</base-button
                  >
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod1"
          class="ml-auto"
          @click="modals.modal3 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>-->
    <modal
      :show.sync="modals.modal4"
      modal-classes="modal-dialog-centered modal-xl"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Erreur
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-fat-remove ni-3x"></i>
        <h4 class="heading mt-4">
          Une erreur grave c'est produite ! Veuillez contacter le cabinet au
          05.61.83.29.13 ou réessayer.
        </h4>
        <br />
        <h5>Code Erreur : NO_DATA_RECEIVE</h5>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal4 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modals.modal5"
      modal-classes="modal-dialog-centered modal-lg"
    >
      <h4
        slot="header"
        class="modal-title"
        id="modal-title-notification"
        style="color: #222222;"
      >
        Choisissez votre moyen de paiement
      </h4>

      <div class="py-3 text-center">
        <h4 class="heading mt-4" style="color: #222222;">
          Vous avez différentes options :
        </h4>
        <br /><br />
        <div class="row">
          <div class="col-md-6">
            <div class="row pb-5">
              <div class="col-md-12">
                <router-link to="/paiement">
                  <base-button
                    block
                    class="btn-icon"
                    type="anhod1"
                    icon="ni ni-credit-card"
                    @click="modals.modal5 = false"
                    >Régler par CB</base-button
                  >
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <base-button
                  block
                  class="btn-icon"
                  type="anhod1"
                  icon="ni ni-credit-card"
                  @click="(modals.modal5 = false), pdf()"
                  >Régler par Virement Bancaire</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod1"
          class="ml-auto"
          @click="modals.modal5 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <div
      class="card card-contact card-raised"
      id="main"
      style="background-color: #3D3D3D;"
    >
      <div class="row">
        <div class="col-lg-12 pr-md-0">
          <div class="card-body txt">
            <h4 style="color: white;">
              Effectuez votre règlement dès aujourd'hui
            </h4>
          </div>
        </div>
      </div>
    </div>
    <br /><br />
    <div class="container pb-100">
      <div class="row">
        <div class="col-md-4 pb-10">
          <h3>Votre solde actuel :</h3>
        </div>
        <div class="col-md-4 txt">
          <spinner class="text-anhod1 mr-2" v-show="spinner.restant"></spinner>
          <h3>
            <a v-show="value.restant">{{ data.restant }} €</a>
          </h3>
        </div>
        <div class="col-md-4"></div>
      </div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4 pb-2" style="text-align: right">
          <base-button
            block
            type="anhod1"
            text-color="white"
            @click="modals.modal5 = true"
          >
            Effectuer le<br />
            règlement
          </base-button>
        </div>
        <div class="col-md-4">
          <base-button
            block
            type="anhod2"
            text-color="white"
            @click="modals.modal2 = true"
          >
            Vous ne pouvez pas<br />
            régler le solde aujourd'hui ?
          </base-button>
        </div>
      </div>
    </div>
    <div class="part">
      <h1 class="hr">Mon Dossier</h1>
      <div class="row pt-50 pb-50">
        <div class="col-md-2"></div>
        <div class="col-md-5">
          <div class="row pb-10">
            <div class="col-md-4 pb-3">
              <base-button block simple type="anhod2" @click="btn = 1">
                Votre dette
              </base-button>
              <div v-if="btn == 1" class="bottom-arrow pt-1"></div>
            </div>
            <div class="col-md-4 pb-3">
              <base-button block type="anhod2" @click="btn = 2">
                <div v-if="data.facture_length > 1">Factures</div>
                <div v-if="data.facture_length == 1">Facture</div>
              </base-button>
              <div v-if="btn == 2" class="bottom-arrow pt-1"></div>
            </div>
            <div class="col-md-4 pb-3">
              <base-button block simple type="anhod2" @click="btn = 3">
                <div v-if="data.versement_length > 1">Versements</div>
                <div v-if="data.versement_length <= 1">Versement</div>
              </base-button>
              <div v-if="btn == 3" class="bottom-arrow pt-1"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div v-if="btn == 1">
                <div class="bg-anhod3">
                  <b>
                    <div class="row">
                      <div class="col-md-6 pl-5">Vous devez</div>
                      <div class="col-md-6 pr-5" style="text-align: right">
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.global"
                        ></spinner>
                        <a v-show="value.global">{{ data.global }} €</a>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 pl-5">À</div>
                      <div class="col-md-6 pr-5" style="text-align: right">
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.client"
                        ></spinner>
                        <a v-show="value.client">{{ data.client }}</a>
                      </div>
                    </div>
                  </b>
                </div>
                <br />
                <h1 class="hr-2 pb-2"></h1>
                <div class="bg-anhod3">
                  <div class="row">
                    <div class="col-md-6 pl-5">Montant Principal</div>
                    <div class="col-md-6 pr-5" style="text-align: right">
                      <spinner
                        class="text-anhod1 mr-2"
                        v-show="spinner.principal"
                      ></spinner>
                      <a v-show="value.principal">{{ data.principal }} €</a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 pl-5">Intérêts & Accessoires</div>
                    <div class="col-md-6 pr-5" style="text-align: right">
                      <spinner
                        class="text-anhod1 mr-2"
                        v-show="spinner.interet_accessoire"
                      ></spinner>
                      <a v-show="value.interet_accessoire"
                        >{{ data.interet_accessoire }} €</a
                      >
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 pl-5">Vos versements</div>
                    <div class="col-md-6 pr-5" style="text-align: right">
                      <spinner
                        class="text-anhod1 mr-2"
                        v-show="spinner.paye"
                      ></spinner>
                      <div v-if="data.paye == 0">
                        <a v-show="value.paye">{{ data.paye }} €</a>
                      </div>
                      <div v-if="data.paye != 0">
                        <a v-show="value.paye">-{{ data.paye }} €</a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 pl-5"><b>Solde à régler</b></div>
                    <div class="col-md-6 pr-5" style="text-align: right">
                      <spinner
                        class="text-anhod1 mr-2"
                        v-show="spinner.restant"
                      ></spinner>
                      <a v-show="value.restant"
                        ><b>{{ data.restant }} €</b></a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="btn == 2">
                <div v-for="factures in data.factures" :key="factures.id">
                  <div class="bg-anhod3">
                    <div class="row">
                      <div class="col-md-6 pl-5">Date de la facture</div>
                      <div class="col-md-6 pr-5" style="text-align: right">
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.date_facture"
                        ></spinner>
                        <a v-show="value.date_facture">{{ factures.Date }}</a>
                      </div>
                    </div>
                  </div>
                  <div class="bg-anhod3">
                    <div class="row">
                      <div class="col-md-6 pl-5">
                        Principal
                      </div>
                      <div class="col-md-6 pr-5" style="text-align: right">
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.montant_facture"
                        ></spinner>
                        <a v-show="value.montant_facture"
                          >{{ factures.Montant }} €</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="bg-anhod3">
                    <div class="row">
                      <div class="col-md-6 pl-5">
                        Solde en Principal
                      </div>
                      <div class="col-md-6 pr-5" style="text-align: right">
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.solde_facture"
                        ></spinner>
                        <a v-show="value.solde_facture"
                          >{{ factures.Solde }} €</a
                        >
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <div v-if="btn == 3">
                <div class="bg-anhod3">
                  <div class="row">
                    <div class="col-md-6 pl-5">Total à régler</div>
                    <div class="col-md-6 pr-5" style="text-align: right">
                      <spinner
                        class="text-anhod1 mr-2"
                        v-show="spinner.global"
                      ></spinner>
                      <a v-show="value.global">{{ data.global }} €</a>
                    </div>
                  </div>
                </div>
                <div class="bg-anhod3">
                  <div class="row">
                    <div class="col-md-6 pl-5">Déjà réglé</div>
                    <div class="col-md-6 pr-5" style="text-align: right">
                      <spinner
                        class="text-anhod1 mr-2"
                        v-show="spinner.paye"
                      ></spinner>
                      <a v-show="value.paye">{{ data.paye }} €</a>
                    </div>
                  </div>
                </div>
                <br />
                <h1 class="hr-2 pb-2"></h1>
                <div class="bg-anhod3" v-if="value.versements == false">
                  <div class="row">
                    <div
                      class="col-md-12 pl-5"
                      style="color: #e52d27; font-size: 1.25em;"
                    >
                      Vous n'avez encore rien réglé
                    </div>
                  </div>
                </div>
                <table class="table table-striped" v-show="value.versements">
                  <thead>
                    <tr>
                      <th style="font-size: 1.25em;">Date</th>
                      <th style="font-size: 1.25em;">Type</th>
                      <th style="font-size: 1.25em;">Montant</th>
                      <th style="font-size: 1.25em;">Moyen de paiement</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="versements in data.versements"
                      :key="versements.id"
                    >
                      <td>
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.versements"
                        ></spinner>
                        <a style="font-size: 1.25em;">{{ versements[0] }}</a>
                      </td>
                      <td>
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.versements"
                        ></spinner>
                        <a style="font-size: 1.25em;">{{ versements[1] }}</a>
                      </td>
                      <td>
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.versements"
                        ></spinner>
                        <a style="font-size: 1.25em;">{{ versements[2] }}</a>
                      </td>
                      <td>
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.versements"
                        ></spinner>
                        <a
                          v-show="value.versements"
                          style="font-size: 1.25em;"
                          >{{ versements[3] }}</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-2">
          <router-link to="/paiement">
            <div class="row pb-3">
              <base-button
                block
                class="btn-icon"
                type="anhod1"
                icon="ni ni-credit-card"
                >Effectuer le règlement par CB</base-button
              >
            </div>
          </router-link>
          <div class="row pb-3">
            <base-button
              block
              class="btn-icon"
              type="anhod1"
              icon="ni ni-curved-next"
              @click="pdf()"
              >Effectuer le règlement par Virement</base-button
            >
          </div>
          <!-- Btn quand échéancier actif
         <div class="row pb-3">
           <base-button
             block
             class="btn-icon"
             type="anhod1"
             icon="ni ni-calendar-grid-58"
             v-scroll-to="'#echeancier'"
             >Échéancier</base-button
           >
          </div>-->
          <router-link to="/messages/1">
            <div class="row pb-3">
              <base-button
                block
                class="btn-icon"
                type="anhod1"
                icon="ni ni-email-83"
                >Envoyer un message</base-button
              >
            </div>
          </router-link>
        </div>
        <div class="col-md-2"></div>
      </div>
    </div>
    <!-- ECHEANCIER
    <div class="part">
      <h1 class="hr" id="echeancier">Échéancier</h1>
      <div class="container">
        <div class="row pt-50">
          <div class="col-md-5">
            <div class="row">
              <div
                class="col-md-12"
                v-if="data.echeance_last_montant == data.echeance_montant"
              >
                <card
                  class="card-pricing text-center"
                  headerClasses="bg-transparent"
                  footerClasses="bg-transparent"
                  style="background-image: url('img/ill/pattern_pricing1.svg"
                >
                  <template slot="header">
                    <h6 class="text-uppercase ls-1 py-3 mb-0">
                      Modalités de l'échéancier
                    </h6>
                  </template>
                  <template slot="body">
                    <div class="display-2">
                      <spinner
                        class="text-anhod1 mr-2"
                        v-show="spinner.echeance_montant"
                      ></spinner>
                      <a v-show="value.echeance_montant"
                        >{{ data.echeance_montant }} € / Mois</a
                      >
                    </div>
                    <br />
                    <span
                      ><spinner
                        class="text-anhod1 mr-2"
                        v-show="spinner.echeance_montant"
                      ></spinner>
                      <a v-show="value.echeance_montant"
                        >pendant <b>{{ data.echeance_delai }}</b> Mois
                      </a></span
                    >
                    <ul class="list-unstyled my-4">
                      <li class="align-items-center">
                        <b class="text-anhod2">Dont frais : </b>
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.echeance_frais"
                        ></spinner>
                        <span
                          ><a v-show="value.echeance_frais" style="color: #222;"
                            >{{ data.echeance_frais }} €</a
                          ></span
                        >
                      </li>
                      <li class="align-items-center">
                        <b class="text-anhod2">Dont indemnités : </b>
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.echeance_indemnites"
                        ></spinner>
                        <span
                          ><a
                            v-show="value.echeance_indemnites"
                            style="color: #222;"
                            >{{ data.echeance_indemnites }} €</a
                          ></span
                        >
                      </li>
                      <li class="align-items-center">
                        <b class="text-anhod2">Dont intérêts : </b>
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.echeance_interets"
                        ></spinner>
                        <span
                          ><a
                            v-show="value.echeance_interets"
                            style="color: #F222;"
                            >{{ data.echeance_interets }} €</a
                          ></span
                        >
                      </li>
                      <li class="align-items-center">
                        <b class="text-anhod2">Total : </b>
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.global"
                        ></spinner>
                        <span
                          ><a v-show="value.global" style="color: #222;"
                            >{{ data.restant }} €</a
                          ></span
                        >
                      </li>
                    </ul>
                  </template>
                </card>
              </div>
              <div
                class="col-md-12"
                v-if="data.echeance_last_montant != data.echeance_montant"
              >
                <card
                  class="card-pricing text-center"
                  headerClasses="bg-transparent"
                  footerClasses="bg-transparent"
                  style="background-image: url('img/ill/pattern_pricing1.svg"
                >
                  <template slot="header">
                    <h6 class="text-uppercase ls-1 py-3 mb-0">
                      Modalités de l'échéancier
                    </h6>
                  </template>
                  <template slot="body">
                    <div class="display-2">
                      <spinner
                        class="text-anhod1 mr-2"
                        v-show="spinner.echeance_montant"
                      ></spinner>
                      <a v-show="value.echeance_montant"
                        >{{ data.echeance_montant }} € / Mois</a
                      >
                    </div>
                    <br />
                    <span
                      ><spinner
                        class="text-anhod1 mr-2"
                        v-show="spinner.echeance_montant"
                      ></spinner>
                      <a v-show="value.echeance_montant"
                        >pendant <b>{{ data.echeance_delai - 1 }}</b> Mois et
                        <b>1</b> Mois à
                      </a></span
                    >
                    <span>
                      <a v-show="value.echeance_last_montant"
                        ><b>{{ data.echeance_last_montant }}</b></a
                      ><spinner
                        class="text-anhod1 mr-2"
                        v-show="spinner.echeance_last_montant"
                      ></spinner>
                      €</span
                    >
                    <ul class="list-unstyled my-4">
                      <li class="align-items-center">
                        <b class="text-anhod2">Dont frais : </b>
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.echeance_frais"
                        ></spinner>
                        <span
                          ><a v-show="value.echeance_frais" style="color: #222;"
                            >{{ data.echeance_frais }} €</a
                          ></span
                        >
                      </li>
                      <li class="align-items-center">
                        <b class="text-anhod2">Dont indemnités : </b>
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.echeance_indemnites"
                        ></spinner>
                        <span
                          ><a
                            v-show="value.echeance_indemnites"
                            style="color: #222;"
                            >{{ data.echeance_indemnites }} €</a
                          ></span
                        >
                      </li>
                      <li class="align-items-center">
                        <b class="text-anhod2">Dont intérêts : </b>
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.echeance_interets"
                        ></spinner>
                        <span
                          ><a
                            v-show="value.echeance_interets"
                            style="color: #F222;"
                            >{{ data.echeance_interets }} €</a
                          ></span
                        >
                      </li>
                      <li class="align-items-center">
                        <b class="text-anhod2">Total : </b>
                        <spinner
                          class="text-anhod1 mr-2"
                          v-show="spinner.global"
                        ></spinner>
                        <span
                          ><a v-show="value.global" style="color: #222;"
                            >{{ data.restant }} €</a
                          ></span
                        >
                      </li>
                    </ul>
                  </template>
                </card>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-button
                  block
                  type="anhod1"
                  text-color="white"
                  @click="modals.modal3 = true"
                >
                  L'échéancier ne<br />
                  vous convient pas ?
                </base-button>
              </div>
            </div>
          </div>
          <div class="col-md-7">
            <div class="card card-contact card-raised pt-25 pb-50 bg-lighter">
              <div class="row pb-5">
                <div class="col-md-4 pl-5">Plus qu'une étape</div>
                <div class="col-md-7"></div>
              </div>
              <div class="row">
                <div class="col-md-4 pb-5 pl-5">
                  Jour de <br />prélèvement
                  <a style="color: red;">*</a>
                </div>
                <div class="col-md-7">
                  <choices-single
                    :options="option_jour"
                    v-model="jour_prelevement"
                    data-select-text="Cliquer"
                  >
                    <option disabled value="0">Select one</option>
                  </choices-single>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 pb-5 pl-5">
                  E-mail <a style="color: red;">*</a>
                </div>
                <div class="col-md-7">
                  <base-input
                    placeholder=" Adresse mail"
                    addonLeftIcon="ni ni-email-83"
                    name="section"
                    v-model="mail"
                    input-classes="base_input"
                  ></base-input
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 pb-5 pl-5">
                  Validation de l'échéancier Carte Bancaire
                  <a style="color: red;">*</a>
                </div>
                <div class="col-md-7">
                  <base-checkbox class="mb-3" v-model="checkbox_carte">
                    J'accepte l'enregistrement crypté de ma carte bancaire pour
                    effectuer les prélèvements.
                  </base-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 pb-5 pl-5">
                  Conditions <a style="color: red;">*</a>
                </div>
                <div class="col-md-7">
                  <base-checkbox class="mb-3" v-model="checkbox_cgv">
                    J'accepte les
                    <a
                      @click="modals.modal1 = true"
                      style="text-decoration: underline;"
                      >conditions générales de vente</a
                    >
                  </base-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col-md-8"></div>
                <div class="col-md-3">
                  <base-button block type="anhod1" @click="Validation()"
                    >Valider</base-button
                  >
                </div>
                <div class="col-md-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
//import ChoicesSingle from "@/components/SingleSelect"; Pour l'échénacier
import Modal from "@/components/Modal";
import axios from "axios";
import router from "@/router";
import { HTTP_REQUEST } from "../constants/constantes";
import Spinner from "@/components/Spinner";
export default {
  components: {
    //ChoicesSingle,
    Modal,
    Spinner
  },
  name: "Recouvrement",
  data() {
    return {
      option_jour: [
        { id: 1, text: "5 du mois" },
        { id: 2, text: "20 du mois" }
      ],

      modals: {
        modal1: false,
        modal2: false,
        modal3: false,
        modal4: false,
        modal5: false
      },
      data: {
        restant: 0,
        paye: 0,
        global: 0,
        moitier_global: 0,
        global_afficher: "Si ceci s'affiche",
        client: 0,
        principal: 0,
        interet_accessoire: 0,
        factures: [],
        facture_length: 0,
        versements: [],
        versement_length: 0,
        echeance_delai: 0,
        echeance_montant: 0,
        echeance_last_montant: 0,
        echeance_frais: 0,
        echeance_indemnites: 0,
        echeance_interets: 0
      },
      spinner: {
        restant: true,
        paye: true,
        global: true,
        client: true,
        principal: true,
        interet_accessoire: true,
        versements: true,
        solde_facture: true,
        montant_facture: true,
        date_facture: true,
        echeance_delai: true,
        echeance_montant: true,
        echeance_last_montant: true,
        echeance_frais: true,
        echeance_indemnites: true,
        echeance_interets: true
      },
      value: {
        restant: false,
        paye: false,
        global: false,
        client: false,
        principal: false,
        interet_accessoire: false,
        versements: false,
        solde_facture: false,
        montant_facture: false,
        date_facture: false,
        echeance_delai: false,
        echeance_montant: false,
        echeance_last_montant: false,
        echeance_frais: false,
        echeance_indemnites: false,
        echeance_interets: false
      },

      jour_prelevement: "",
      periode: "",
      mail: "",

      checkbox_carte: false,
      checkbox_cgv: false,

      btn: 1,

      codeClient: "",
      codeDebiteur: "",
      Dossier: "",

      jour_prelevement_check: false,
      mail_check: false,
      cb_check: false,
      cgv_check: false,

      message_erreur_jour_prelevement: "",
      message_erreur_mail: "",
      message_erreur_cb: "",
      message_erreur_cgv: ""
    };
  },
  created: function() {
    this.getData();
  },
  methods: {
    // Ouverture du PDF
    pdf: function() {
      window.open("https://www.telereglement.fr/RIB.pdf", "_blank");
    },
    // Récupération des informations pour l'affichage du dossier
    getData: function() {
      if (this.$store.state.tokens != "") {
        const self = this;
        let getDataApi = async function() {
          let action = "action=getInfo";
          let token = "&token=" + self.$store.state.tokens;
          var postData = action + token;
          const retourRequete = await axios.post(HTTP_REQUEST, postData);
          return retourRequete;
        };
        getDataApi().then(function(retourApi) {
          if (retourApi.data) {
            if (retourApi.data == "INVALID") {
              self.$store.commit("removeToken", 0);
              self.$store.commit("removeSolde", 0);
              router.push("/login/1/0/0");
            } else if (retourApi.data == "INVALID PARAMS") {
              router.push("/login/1/0/0");
            } else {
              let data = JSON.parse(retourApi.data);
              if (data["data"]["RESTANT"] != "ERROR") {
                self.data.restant = data["data"]["RESTANT"]; // Restant à payer
                if (self.$store.state.soldes == "") {
                  self.$store.commit("addSolde", self.data.restant);
                }
                self.spinner.restant = false;
                self.value.restant = true;
              }
              if (data["data"]["GLOBAL_PAYE"] != "ERROR_QUERY_2") {
                self.data.paye = data["data"]["GLOBAL_PAYE"]; // Déjà payé
                self.data.global_afficher =
                  "Vous avez déja payé " + self.data.paye + "€"; // Affichage de la valeur payé
                self.spinner.paye = false;
                self.value.paye = true;
              }
              if (data["data"]["GLOBAL"] != "ERROR_QUERY_1") {
                self.data.global = data["data"]["GLOBAL"]; // Montant Total
                self.data.moitier_global = parseFloat(self.data.global) / 2; // Moitier du montant total
                self.spinner.global = false;
                self.value.global = true;
              }
              if (data["data"]["CLIENT"] != "ERROR_QUERY_3") {
                self.data.client = data["data"]["CLIENT"]; // Nom client
                self.spinner.client = false;
                self.value.client = true;
              }
              if (
                data["data"]["GLOBAL"] != "ERROR_QUERY_1" &&
                data["data"]["INTERETS_GLOBAL"] != "ERROR_QUERY_4"
              ) {
                self.data.principal = data["data"]["PRINCIPAL"]; // Solde sans intérets & accessoires
                self.spinner.principal = false;
                self.value.principal = true;
              }
              if (data["data"]["INTERETS_GLOBAL"] != "ERROR_QUERY_4") {
                self.data.interet_accessoire = data["data"]["INTERETS_GLOBAL"]; // Intérets & Accessoires
                self.spinner.interet_accessoire = false;
                self.value.interet_accessoire = true;
              }
              if (
                data["data"]["FACTURE"] != "ERROR_QUERY_6" &&
                data["data"]["FACTURE"] != "ERROR_QUERY_5"
              ) {
                self.data.factures = data["data"]["FACTURE"]; // Facture(s) avec les versements
                let factures = data["data"]["FACTURE"].length;
                self.data.facture_length = factures;
                let i = 0;
                while (i < factures) {
                  self.data.factures[i]["Date"] = self.data.factures[i][
                    "Date"
                  ].replace("Janurary", "Janvier"); // Janvier
                  self.data.factures[i]["Date"] = self.data.factures[i][
                    "Date"
                  ].replace("February", "Février"); // Février
                  self.data.factures[i]["Date"] = self.data.factures[i][
                    "Date"
                  ].replace("March", "Mars"); // Mars
                  self.data.factures[i]["Date"] = self.data.factures[i][
                    "Date"
                  ].replace("April", "Avril"); // Avril
                  self.data.factures[i]["Date"] = self.data.factures[i][
                    "Date"
                  ].replace("May", "Mai"); // Mai
                  self.data.factures[i]["Date"] = self.data.factures[i][
                    "Date"
                  ].replace("June", "Juin"); // Juin
                  self.data.factures[i]["Date"] = self.data.factures[i][
                    "Date"
                  ].replace("July", "Juillet"); // Juillet
                  self.data.factures[i]["Date"] = self.data.factures[i][
                    "Date"
                  ].replace("August", "Août"); // Août
                  self.data.factures[i]["Date"] = self.data.factures[i][
                    "Date"
                  ].replace("September", "Septembre"); // Septembre
                  self.data.factures[i]["Date"] = self.data.factures[i][
                    "Date"
                  ].replace("October", "Octobre"); // Octobre
                  self.data.factures[i]["Date"] = self.data.factures[i][
                    "Date"
                  ].replace("November", "Novembre"); // Novembre
                  self.data.factures[i]["Date"] = self.data.factures[i][
                    "Date"
                  ].replace("December", "Décembre"); // Décembre
                  if (data["data"]["FACTURE"][i]["Restant"]) {
                    let restant_var = data["data"]["FACTURE"][i]["Restant"];
                    let date_var = data["data"]["FACTURE"][i]["Date_versement"];
                    let facture = data["data"]["FACTURE"][i]["Restant"].length;
                    let y = 0;
                    while (y < facture) {
                      let restant = restant_var[y];
                      let date = date_var[y];
                      let paiement = [];
                      paiement.push(date);
                      paiement.push("Versement");
                      paiement.push(restant + "€");
                      paiement.push("MODALITE");
                      self.data.versements.push(paiement);
                      y++;
                    }
                    self.value.versements = true;
                  }
                  i++;
                }
                self.data.versement_length = self.data.versements.length;

                self.spinner.versements = false;
                self.spinner.solde_facture = false;
                self.spinner.montant_facture = false;
                self.spinner.date_facture = false;
                self.value.solde_facture = true;
                self.value.montant_facture = true;
                self.value.date_facture = true;
              }
              if (data["data"]["ECHEANCE"] != "ERROR_QUERY_7") {
                self.data.echeance_delai = data["data"]["ECHEANCE"]["Duree"]; // Délai accorder
                self.spinner.echeance_delai = false;
                self.value.echeance_delai = true;
                self.data.echeance_montant =
                  data["data"]["ECHEANCE"]["Montant"]; // Montant par mois
                self.spinner.echeance_montant = false;
                self.value.echeance_montant = true;
                self.data.echeance_last_montant =
                  data["data"]["ECHEANCE"]["lastMontant"]; // Montant pour le dernier mois
                self.spinner.echeance_last_montant = false;
                self.value.echeance_last_montant = true;
              }
              if (data["data"]["FRAIS"] != "ERROR_QUERY_8") {
                self.data.echeance_frais = data["data"]["FRAIS"]; // Frais (Code_libelle = 6,7,5,2)
                self.spinner.echeance_frais = false;
                self.value.echeance_frais = true;
                self.data.echeance_indemnites = data["data"]["INDEMNITES"]; // Indeminités (Code_libelle = 4)
                self.spinner.echeance_indemnites = false;
                self.value.echeance_indemnites = true;
                self.data.echeance_interets = data["data"]["INTERETS"]; // Intérêts (Code_libelle = 3)
                self.spinner.echeance_interets = false;
                self.value.echeance_interets = true;
              }
            }
          } else {
            self.modals.modal4 = true;
          }
        });
      } else {
        router.push("/login/1/0/0");
      }
    }
    // Redirection et vérification des champs pour le paiement multiple
    /*Validation: function() {
      this.jour_prelevement_check = false;
      this.mail_check = false;
      this.cb_check = false;
      this.cgv_check = false;
      const email = /^(([^<>()[]\.,;:s@]+(.[^<>()[]\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/;
      if (this.jour_prelevement == "") {
        this.message_erreur_jour_prelevement =
          "Veuillez selectionner un jour de prélèvement.";
        this.jour_prelevement_check = true;
        this.$toast.open({
          message: this.message_erreur_jour_prelevement,
          type: "default",
          duration: 7500,
          position: "top-right"
        });
      }
      if (this.mail == "") {
        this.message_erreur_mail = "Veuillez renseigner une adresse mail.";
        this.mail_check = true;
        this.$toast.open({
          message: this.message_erreur_mail,
          type: "default",
          duration: 7500,
          position: "top-right"
        });
      } else if (email.test(this.mail) == false) {
        this.message_erreur_mail =
          "Veuillez renseigner une adresse mail valide.";
        this.mail_check = true;
        this.$toast.open({
          message: this.message_erreur_mail,
          type: "default",
          duration: 7500,
          position: "top-right"
        });
      }
      if (this.checkbox_carte == false) {
        this.message_erreur_cb =
          "Veuillez accepter l'enregistrement cryptée de votre carte bancaire.";
        this.cb_check = true;
        this.$toast.open({
          message: this.message_erreur_cb,
          type: "default",
          duration: 7500,
          position: "top-right"
        });
      }
      if (this.checkbox_cgv == false) {
        this.message_erreur_cgv =
          "Veuillez accepter les conditions générales de vente.";
        this.cgv_check = true;
        this.$toast.open({
          message: this.message_erreur_cgv,
          type: "default",
          duration: 7500,
          position: "top-right"
        });
      }
      if (
        this.jour_prelevement_check == false &&
        this.mail_check == false &&
        this.cb_check == false &&
        this.cgv_check == false
      ) {
        console.log("TOUT LES CHAMPS SONT OK"); // Redirection sur la platforme de paiement en plusieurs fois
      }
    }*/
  }
};
</script>

<style scoped>
.txt {
  text-align: center;
}
.col-md-6 {
  color: #222;
  font-size: 1.15em;
}
.petit {
  background-image: url("/img/brand/background.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 200%;
  background-attachment: fixed;
  padding-block-end: 20rem;
}
.bottom-arrow {
  border-bottom: 5px solid #222;
}
.bottom-arrow:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-top: 15px solid #222;
  border-left: 25px solid transparent;
  border-right: 25px solid transparent;
}
.choices__list--single {
  padding-top: 0;
}
.rectangle {
  border-radius: 8px;
  border: 3px solid dimgray;
  width: 100%;
  height: 45%;
}
base_input {
  font-size: 10em;
}
.hr {
  align-items: center;
  display: flex;
  text-align: center;
  color: #222;
  font-size: 2em;
}

.hr::before,
.hr::after {
  border-top: 0.15em solid;
  content: "";
  flex: 1;
  margin: 0 0.5em;
  color: #b2aa68;
}
.hr-2 {
  align-items: center;
  display: flex;
  text-align: center;
  color: #222;
  font-size: 2em;
}

.hr-2::before,
.hr-2::after {
  border-top: 0.15em solid;
  content: "";
  flex: 1;
  margin: 0 0.5em;
  color: #222;
}
@media screen and (max-width: 768px) {
  #main {
    visibility: hidden;
  }
}
</style>
